// 视频初剪
import videoClipsIndex from '@/views/edit/videoClips/index'

const animationRoutes = Array.from({ length: 23 }, (_, i) => ({
  path: `videoClips/animation/index${i + 1}`,
  name: `videoClips/animation/Index${i + 1}`,
  component: () => import(`@/views/edit/videoClips/animation/index${i + 1}.vue`)
}))
const clipRoutes = Array.from({ length: 16 }, (_, i) => ({
  path: `videoClips/clip/index${i + 1}`,
  name: `videoClips/clip/Index${i + 1}`,
  component: () => import(`@/views/edit/videoClips/clip/index${i + 1}.vue`)
}))
const specialRoutes = Array.from({ length: 14 }, (_, i) => ({
  path: `videoClips/special/index${i + 1}`,
  name: `videoClips/special/Index${i + 1}`,
  component: () => import(`@/views/edit/videoClips/special/index${i + 1}.vue`)
}))

export default {
  path: '/edit',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'videoClips/index',
      name: 'videoClipsIndex',
      component: videoClipsIndex
    },
    // 视频初剪，开始
    ...animationRoutes,
    ...clipRoutes,
    ...specialRoutes
    // 视频初剪，结束

  ]
}
